import AustriaFlag from '../svgs/AustriaFlag';
import GermanFlag from '../svgs/GermanFlag';
import { memo } from 'react';
import { BankCountry } from '../../services/interfaces/bank.interface';

interface CountrySelectProps {
	country: BankCountry;
	onCountryChange(country: BankCountry): void;
}

const CountrySelect = ({ country, onCountryChange }: CountrySelectProps) => {
	const onClick = () => {
		const nextCountry = country === 'AT' ? 'DE' : 'AT';
		onCountryChange(nextCountry);
	};

	return (
		<div id="bank-select" onClick={onClick}>
			{CountryMap[country]}
		</div>
	);
};

export default memo(CountrySelect);

const CountryMap: Record<BankCountry, JSX.Element> = {
	AT: <AustriaFlag />,
	DE: <GermanFlag />
};
